@if (type() === 'check') {
  <span class="check-reveal block">
    <app-icon name="check" />
  </span>
} @else if (type() === 'question') {
  <!-- Ring flips in on X, then the mark spins on Y -->
  <div class="question-ring flex h-20 w-20 items-center justify-center rounded-full border-4 border-question text-question">
    <span class="question-mark text-5xl leading-none font-semibold">?</span>
  </div>
} @else if (type() === 'warning') {
  <!-- Ring flips in on X while the mark wobbles into place -->
  <div class="warning-ring flex h-20 w-20 items-center justify-center rounded-full border-4 border-warning text-warning">
    <span class="warning-mark text-5xl leading-none font-semibold">!</span>
  </div>
} @else if (type() === 'info') {
  <!-- Ring flips in on X while the mark wobbles into place -->
  <div class="info-ring flex h-20 w-20 items-center justify-center rounded-full border-4 border-info text-info">
    <span class="info-mark text-5xl leading-none font-semibold">i</span>
  </div>
} @else if (type() === 'error') {
  <!-- Ring flips in on X while the cross pops up from below -->
  <div class="error-ring flex h-20 w-20 items-center justify-center rounded-full border-4 border-error">
    <span class="error-mark relative block h-12 w-12">
      <span class="absolute top-1/2 left-0 h-1.25 w-full -translate-y-1/2 rotate-45 rounded-sm bg-error"></span>
      <span class="absolute top-1/2 left-0 h-1.25 w-full -translate-y-1/2 -rotate-45 rounded-sm bg-error"></span>
    </span>
  </div>
} @else if (type() === 'spinner') {
  <!-- Two 140deg arcs on a thin ring, matching the design proportions -->
  <svg class="h-14 w-14 animate-spin [animation-direction:reverse] motion-reduce:animate-none" viewBox="0 0 64 64" fill="none">
    <defs>
      <linearGradient [attr.id]="spinnerRightGradientId" gradientUnits="userSpaceOnUse" x1="41.23" y1="6.63" x2="41.23" y2="57.37">
        <stop offset="0" class="[stop-color:var(--color-spinner-right)]" />
        <stop offset="1" stop-opacity="0" class="[stop-color:white]" />
      </linearGradient>
      <linearGradient [attr.id]="spinnerLeftGradientId" gradientUnits="userSpaceOnUse" x1="22.77" y1="57.37" x2="22.77" y2="6.63">
        <stop offset="0" class="[stop-color:var(--color-spinner-left)]" />
        <stop offset="1" stop-opacity="0" class="[stop-color:var(--color-spinner-left-fade)]" />
      </linearGradient>
    </defs>
    <g stroke-width="10" stroke-linecap="round">
      <path d="M 41.23 6.63 A 27 27 0 0 1 41.23 57.37" [attr.stroke]="'url(#' + spinnerRightGradientId + ')'" />
      <path d="M 22.77 57.37 A 27 27 0 0 1 22.77 6.63" [attr.stroke]="'url(#' + spinnerLeftGradientId + ')'" />
    </g>
  </svg>
} @else if (type() === 'bounce-loader') {
  <div class="flex items-start gap-2">
    @for (dot of dots; track dot) {
      <div class="flex flex-col items-center gap-0.5" [style.--dot-delay]="dot * 0.2 + 's'">
        <span class="sending-dot h-3 w-3 rounded-full bg-primary"></span>
        <span class="sending-dot-mirror h-3 w-3 rounded-full bg-linear-to-b from-primary/30 to-transparent"></span>
      </div>
    }
  </div>
}
